/**
 * VISIBILITY CUSTOM ELEMENT
 * Abstracted from several other components that handle toggling state. Created for DRYness.
 */

export class VisiblityElement extends HTMLElement {
  constructor() {
    super()

    // CUSTOM METHODS
    // Adding custom methods here to deal with 'this' issues

    this.handleShow = () => {
      this.dataset.ui = 'visible'
    }

    this.handleHide = () => {
      this.dataset.ui = undefined
      this.handleRemoveAnchor()
    }

    this.handleToggle = () => {
      if (this.dataset.ui === 'visible') this.handleHide()
      else this.handleShow()
    }

    this.handleEventShow = (event) => {
      if (event.detail.target !== this.dataset.id) return
      this.handleShow()
    }

    this.handleEventHide = (event) => {
      if (event.detail.target !== this.dataset.id) return
      this.handleHide()
    }

    this.handleAnchorOpen = () => {
      const hash = window.location.hash.replace('#', '')
      const openModals = document.querySelectorAll(`[data-id="${this.dataset.id}"][data-ui="visible"]`)
      if (!hash || hash !== this.dataset.id || openModals.length > 0) return
      this.handleShow()
    }

    this.handleRemoveAnchor = () => {
      const [url, id] = window.location.href.split('#')
      if (!id || id !== this.dataset.id) return
      window.history.pushState('', {}, url)
    }
  }

  // Event Dispatchers
  static EVENT_SHOW = 'show'
  static dispatchShow(id) {
    document.dispatchEvent(
      new CustomEvent(VisiblityElement.EVENT_SHOW, {
        detail: {
          target: id
        }
      })
    )
  }

  static EVENT_HIDE = 'hide'
  static dispatchHide(id) {
    document.dispatchEvent(
      new CustomEvent(VisiblityElement.EVENT_HIDE, {
        detail: {
          target: id
        }
      })
    )
  }

  addEventListeners() {
    document.addEventListener(VisiblityElement.EVENT_SHOW, this.handleEventShow.bind(this))
    document.addEventListener(VisiblityElement.EVENT_HIDE, this.handleEventHide.bind(this))
    window.addEventListener('hashchange', this.handleAnchorOpen.bind(this))
    window.addEventListener('load', this.handleAnchorOpen.bind(this))
  }

  removeEventListeners() {
    document.removeEventListener(VisiblityElement.EVENT_SHOW, this.handleEventShow.bind(this))
    document.removeEventListener(VisiblityElement.EVENT_HIDE, this.handleEventHide.bind(this))
    window.removeEventListener('hashchange', this.handleAnchorOpen.bind(this))
    window.removeEventListener('load', this.handleAnchorOpen.bind(this))
  }

  connectedCallback() {
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}

window.VisibilityElement = VisiblityElement
if (!customElements.get('x-visibility')) customElements.define('x-visibility', VisiblityElement)
